import { useContext } from 'react';
import classNames from 'classnames';
import { Theme } from "../../Background/Theme/Theme";
import { Link } from "../../Button/Link/Link";
import { LayoutContext } from "../../../context/layout.context";
import styles from "./Card.module.scss";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var Card = function Card(_ref) {
  var top = _ref.top,
    bottom = _ref.bottom,
    _ref$dropShadow = _ref.dropShadow,
    dropShadow = _ref$dropShadow === void 0 ? false : _ref$dropShadow,
    _ref$link = _ref.link,
    link = _ref$link === void 0 ? '' : _ref$link,
    onClick = _ref.onClick,
    _ref$rowLayout = _ref.rowLayout,
    rowLayout = _ref$rowLayout === void 0 ? false : _ref$rowLayout,
    _ref$newWindow = _ref.newWindow,
    newWindow = _ref$newWindow === void 0 ? false : _ref$newWindow,
    _ref$styleVersion = _ref.styleVersion,
    styleVersion = _ref$styleVersion === void 0 ? 'default' : _ref$styleVersion,
    _ref$cardActionAttrib = _ref.cardActionAttributes,
    cardActionAttributes = _ref$cardActionAttrib === void 0 ? {} : _ref$cardActionAttrib,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var onClickProcessed = function onClickProcessed() {
    if (onClick) {
      onClick(link);
    }
  };
  var layout = useContext(LayoutContext);
  return /*#__PURE__*/_jsx(Theme, {
    theme: "lightBackground",
    children: /*#__PURE__*/_jsxs(Link, {
      url: link,
      onClick: onClickProcessed,
      className: classNames({
        [styles.card]: true,
        [className]: !!className,
        [styles.cardDefault]: styleVersion === 'default',
        [styles.cardV1]: styleVersion === 'v1',
        [styles.cardDropShadow]: dropShadow,
        [styles.cardRowLayout]: rowLayout,
        [styles[layout]]: layout === 'sidebarBody'
      }),
      "data-e2e-name": "card",
      newWindow: newWindow,
      attributes: cardActionAttributes,
      children: [top, bottom]
    })
  });
};